import { PagedList } from '../../admin/types/pagination';
import { LessonHomeworkSubmissionIndexView } from '../types/lesson_homework_submissions';
import { MainV3ApiBase } from './base';

export const UserCourseWorkSubmissionApis = {
  async findAll(page = 1): Promise<PagedList<LessonHomeworkSubmissionIndexView>> {
    return PagedList.fromJson(await MainV3ApiBase.appendPath('users/current/course_work_submissions').get({ page }));
  },
};
